import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import {Toaster} from "sonner";
import "@/App.css";
import React, {Suspense, lazy} from "react"; // <--- Import yahan sahi hai
import {AuthProvider, useAuth} from "@/context/AuthContext";
//import {ThemeProvider} from "@/context/ThemeContext";

const PublicSite = lazy(() => import("@/pages/PublicSite"));
const SubPage = lazy(() => import("@/pages/SubPage"));
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminLayout = lazy(() => import("@/pages/admin/AdminLayout"));

// Admin Imports
const Dashboard = lazy(() => import("@/pages/admin/Dashboard"));
const LeadsAdmin = lazy(() => import("@/pages/admin/LeadsAdmin"));
const PortfolioAdmin = lazy(() => import("@/pages/admin/PortfolioAdmin"));
const TestimonialsAdmin = lazy(() => import("@/pages/admin/TestimonialsAdmin"));
const BlogAdmin = lazy(() => import("@/pages/admin/BlogAdmin"));
const NewsletterAdmin = lazy(() => import("@/pages/admin/NewsletterAdmin"));
const SettingsAdmin = lazy(() => import("@/pages/admin/SettingsAdmin"));
const QueriesAdmin = lazy(() => import("@/pages/admin/QueriesAdmin"));
const PlansAdmin = lazy(() => import("@/pages/admin/PlansAdmin"));
const SecurityAdmin = lazy(() => import("@/pages/admin/SecurityAdmin"));
const NavAdmin = lazy(() => import("@/pages/admin/NavAdmin"));
const MediaAdmin = lazy(() => import("@/pages/admin/MediaAdmin"));

// Client Imports
const ClientLogin = lazy(() => import("@/pages/client/ClientLogin"));
const ClientRegister = lazy(() => import("@/pages/client/ClientRegister"));
const ClientPortal = lazy(() => import("@/pages/client/ClientPortal"));
const PlansPage = lazy(() => import("@/pages/client/PlansPage"));
const RequirementForm = lazy(() => import("@/pages/client/RequirementForm"));

function ProtectedAdminRoute({children}) {
    const {user, loading} = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center font-mono text-xs uppercase tracking-widest"
                 style={{background: "var(--bg)", color: "var(--text-2)"}}>
                Authenticating…
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace/>;
    return children;
}

function ProtectedClientRoute({children}) {
    const {client, clientLoading} = useAuth();
    if (clientLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center font-mono text-xs uppercase tracking-widest"
                 style={{background: "var(--bg)", color: "var(--text-2)"}}>
                Authenticating…
            </div>
        );
    }
    if (!client) return <Navigate to="/login" replace/>;
    return children;
}

// Common Loading Fallback component to prevent layout shifts
const PageLoader = () => (
    <div className="min-h-screen flex items-center justify-center font-mono text-xs uppercase tracking-widest"
         style={{background: "var(--bg)", color: "var(--text-2)"}}>
        Loading...
    </div>
);

export default function App() {
    return (
        // <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Suspense fallback={<PageLoader />}>
                        <Routes>
                            <Route path="/" element={<PublicSite/>}/>
                            <Route path="/page/:slug" element={<SubPage/>}/>

                            {/* Client portal */}
                            <Route path="/login" element={<ClientLogin/>}/>
                            <Route path="/signup" element={<ClientRegister/>}/>
                            <Route path="/portal/plans" element={<PlansPage/>}/>
                            <Route path="/portal"
                                   element={<ProtectedClientRoute><ClientPortal/></ProtectedClientRoute>}/>
                            <Route path="/portal/request/:planSlug"
                                   element={<ProtectedClientRoute><RequirementForm/></ProtectedClientRoute>}/>

                            {/* Admin */}
                            <Route path="/admin/login" element={<AdminLogin/>}/>
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedAdminRoute>
                                        <AdminLayout/>
                                    </ProtectedAdminRoute>
                                }
                            >
                                <Route index element={<Dashboard/>}/>
                                <Route path="queries" element={<QueriesAdmin/>}/>
                                <Route path="plans" element={<PlansAdmin/>}/>
                                <Route path="leads" element={<LeadsAdmin/>}/>
                                <Route path="portfolio" element={<PortfolioAdmin/>}/>
                                <Route path="testimonials" element={<TestimonialsAdmin/>}/>
                                <Route path="blog" element={<BlogAdmin/>}/>
                                <Route path="newsletter" element={<NewsletterAdmin/>}/>
                                <Route path="nav" element={<NavAdmin/>}/>
                                <Route path="media" element={<MediaAdmin/>}/>
                                <Route path="security" element={<SecurityAdmin/>}/>
                                <Route path="settings" element={<SettingsAdmin/>}/>
                            </Route>
                            <Route path="*" element={<Navigate to="/" replace/>}/>
                        </Routes>
                    </Suspense>
                </BrowserRouter>
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "var(--bg-2)",
                            color: "var(--text)",
                            border: "1px solid var(--line)",
                            borderRadius: "12px",
                            fontFamily: "Satoshi, sans-serif",
                        },
                    }}
                />
            </AuthProvider>
        // </ThemeProvider>
    );
}